<!--
  Modal educacional de primer uso (Paso 8 / Fase 6, tarea 6.4).
  Explica una sola vez que la app funciona sin internet y como leer el estado.
  Se marca como visto en localStorage para no volver a mostrarlo.
-->
<script>
    import { onMount } from "svelte";
    import { browser } from "$app/environment";
    import { fade, scale } from "svelte/transition";

    const SEEN_KEY = "cf_offline_intro_seen";
    let visible = $state(false);

    onMount(() => {
        if (browser && localStorage.getItem(SEEN_KEY) !== "1") {
            visible = true;
        }
    });

    function dismiss() {
        if (browser) localStorage.setItem(SEEN_KEY, "1");
        visible = false;
    }
</script>

{#if visible}
    <div
        class="fixed inset-0 z-[70] flex items-center justify-center bg-black/50 p-4"
        transition:fade={{ duration: 150 }}
        role="presentation"
    >
        <div
            class="w-full max-w-sm rounded-xl bg-cf-surface text-cf-text p-6 shadow-2xl"
            transition:scale={{ duration: 180, start: 0.95 }}
        >
            <h2 class="text-lg font-semibold">Funciona sin internet</h2>
            <p class="mt-3 text-sm text-cf-text-sub">
                Esta app funciona aunque te quedes sin señal. Tus cambios se
                guardan en el dispositivo y se sincronizan solos cuando vuelve la
                conexión.
            </p>
            <p class="mt-2 text-sm text-cf-text-sub">
                El indicador abajo a la derecha te muestra cuántos cambios faltan
                subir. Si aparece en <span class="font-medium text-cf-danger"
                    >rojo</span
                >, tocálo para ver qué no se pudo sincronizar.
            </p>
            <button
                type="button"
                onclick={dismiss}
                class="mt-5 w-full rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
            >
                Entendido
            </button>
        </div>
    </div>
{/if}
